import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import { StyledAccommodationRoomTileDetails } from './AccommodationRoomTileDetails'
import { AccommodationRoomTileImageContainer } from './AccommodationRoomTileImage'
import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { isHotelPackage } from 'lib/offer/offerTypes'

const AccommodationRoomTileGrid = styled.div`
  &.hasImage {
    display: grid;
    grid-template:
      "image" ${rem(223)}
      "details" auto / 1fr;

    ${mediaQueryUp.tablet} {
      grid-template:
        "image" ${rem(320)}
        "details" auto / 1fr;
    }

    ${mediaQueryUp.desktop} {
      grid-template: "image details" auto;
      &.image-size-medium {
        grid-template-columns: ${rem(400)} 1fr;
      }
      &.image-size-small {
        grid-template-columns: ${rem(300)} 1fr;
      }
    }

  }
  &:not(.hasImage) {
    display: grid;
    grid-template: "details" auto / 1fr;

    ${mediaQueryUp.tablet} {
      grid-template: "details" auto / 1fr;
    }

    ${mediaQueryUp.desktop} {
      grid-template: "details" auto / 1fr;
    }

    > ${AccommodationRoomTileImageContainer} {
      display: none;
    }
  }

  > ${AccommodationRoomTileImageContainer} {
    grid-area: image;
  }
  > ${StyledAccommodationRoomTileDetails} {
    grid-area: details;
  }
`
interface Props extends PropsWithChildren {
  roomPackage: App.HotelPackage | App.BedbankPackage
  imageSize?: 'small' | 'medium'
}

function AccommodationRoomTile(props: Props) {
  const { roomPackage, imageSize = 'medium', children } = props
  const room = roomPackage ? (isHotelPackage(roomPackage) ? roomPackage.roomType : roomPackage) : null

  return <AccommodationRoomTileGrid className={clsx({ hasImage: !!room?.images?.length }, `image-size-${imageSize}`)}>
    {children}
  </AccommodationRoomTileGrid>
}

export default AccommodationRoomTile
